module.exports = __webpack_public_path__ + "img/5-black.f203ba39.png";